import { Reveal } from '../ui/Reveal'
import { SectionHead } from '../ui/SectionHead'
import { MapWindow } from './MapWindow'
import './Explore.css'

export function Explore() {
  return (
    <section id="explore">
      <div className="wrap">
        <SectionHead eyebrow="Explore" title={<>One map. <em className="s">Everything</em> that's on.</>}>
          Every plan in the city sits on one map. Filter by what you feel like, slide to the time you're free, and tap a pin to see who's going.
        </SectionHead>
        <Reveal><MapWindow /></Reveal>
        <p className="fine center">Example plans on a simplified map of Delhi NCR, drawn from real coordinates. Drag to move around, or use + and −.</p>
      </div>
    </section>
  )
}
